<template>
  <p class="text-body-1 text-lg-h5 mt-10">
    For Android users you can download the APK from
    <a
      class="remove-underline"
      href="https://onedrive.live.com/download?cid=D25E3AABFBD442D5&resid=d25e3aabfbd442d5%2112006&authkey=AFUTx5Dgm91DciU"
      >here</a
    >
    and install it on your phone.
  </p>
</template>
<script>
export default {};
</script>

<style>
</style>